import { Component, Inject, signal } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogModel } from '../confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-confirm-popup',
  templateUrl: './confirm-popup.component.html',
  styleUrls: ['./confirm-popup.component.scss'],
  standalone: false,
})
export class ConfirmPopupComponent {
  title: string;
  message: string;
  isHtmlContent = false;
  confirmButtonText = 'Ok';
  showCancelButton = signal(false);

  constructor(
    public dialogRef: MatDialogRef<ConfirmPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel,
  ) {
    this.title = data.title;
    this.message = data.message;
    this.isHtmlContent = data.isHtmlContent || false;
    this.confirmButtonText = data.confirmButtonText || 'Ok';
    this.showCancelButton.set(data.showCancelButton || false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
